import { default as normalField } from "./normal";
import { default as objectField } from "./object";
import { default as arrayField } from "./array";
export default [normalField, objectField, arrayField];
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/fx-schema-form-react/libs/fields/index.js
// module id = 342
// module chunks = 3